import Swiper from 'swiper/bundle';

export default class Slider {
    constructor() {
        this.$sliders = [...document.querySelectorAll('.js-slider')];
    }

    initSlider() {
        const commonParams = {
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
                waitForTransition: false,
            },
            centeredSlides: true,
            loop: true,
            navigation: {
                nextEl: '.js-slider_nextBtn',
                prevEl: '.js-slider_prevBtn',
            },
            on: {
                init: e => (e.realIndex = 0),
            },
            slideClass: 'js-slider_slide',
            slidesPerView: 'auto',
            speed: 600,
            wrapperClass: 'js-slider_wrapper',
        };

        const addParams = {
            kv: {
                centeredSlides: false,
                on: {
                    init: e => this._initBtn(e),
                    realIndexChange: e => this._changeBtnTxt(e),
                },
                pagination: {
                    bulletActiveClass: '-active',
                    bulletClass: 'kv__pagination__bullet',
                    bulletElement: 'button',
                    clickable: true,
                    el: '.js-slider_pagination',
                },
                slidesPerView: 1,
            },
            top: {
                navigation: false,
                // NOTE:バナー2枚の時の1枚目が中央に来るように数値指定 枚数が増えるのなら調整
                initialSlide: 2,
            },
        };

        for (const $slider of this.$sliders) {
            const key = $slider.className.split(' ')[0];
            const params = { ...commonParams, ...addParams[key] };
            const swipers = new Swiper($slider, params);
        }
    }

    _initBtn(e) {
        this.$slides = e.slides;
        this.$prevBtn = e.el.querySelector('.js-slider_prevBtn');
        this.$nextBtn = e.el.querySelector('.js-slider_nextBtn');

        this._changeBtnTxt(e);
    }

    _changeBtnTxt(e) {
        const prevIndex = e.realIndex < 1 ? this.$slides.length - 1 : e.realIndex - 1;
        const nextIndex = e.realIndex >= this.$slides.length - 1 ? 0 : e.realIndex + 1;

        this.$prevBtn.textContent = this.$slides[prevIndex].dataset.name;
        this.$nextBtn.textContent = this.$slides[nextIndex].dataset.name;
    }
}
